// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2vyQ4","userTouch":"styles_userTouch__Ig7vu","icons":"styles_icons__3ZNUL"};